import { MaterialStatus } from '@mnd-frontend/graphql-schema';
import { Badge, materialStatusToBadgeVariant } from '@mnd-frontend/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

const statusToText = (t: any, status: MaterialStatus): string => {
  switch (status) {
    case MaterialStatus.Scheduled:
      return t('publish.scheduled');
    case MaterialStatus.Published:
      return t('material_state_published');
    case MaterialStatus.Draft:
      return t('material_state_draft');
    default:
      return status;
  }
};

export const ImageStatusPill = React.memo(
  ({ status, showDraft = false }: { status: MaterialStatus; showDraft?: boolean }) => {
    const [t] = useTranslation();
    if (!showDraft && status === MaterialStatus.Draft) {
      return null;
    }

    return <Badge variant={materialStatusToBadgeVariant(status)} text={statusToText(t, status)} />;
  },
);
